import { temAcesso } from '@/shared/auth/temAcesso'

// import regraAcessoRotas from './regrasacesso/RegrasAcessoRota'
// import solicitacoesAcessoRotas from './solicitacoesacesso/SolicitacoesAcessoRotas'
const Relatorios = () => import('./Relatorios.vue')

export default {
    path: 'relatorios',
    name: 'Relatorios',
    component: Relatorios,
    beforeEnter: (to, from, next) => {
        if (temAcesso('RELATORIOS-00')) {
            next()
        }
    },
    children: []
}
